module.exports = __webpack_public_path__ + "img/3.5KVA.a3fb546b.jpeg";